// extracted by mini-css-extract-plugin
export var playIcon = "index-module--playIcon--3d6c2";
export var playIconPlay = "index-module--playIconPlay--95506";
export var playIconPlayActive = "index-module--playIconPlayActive--ba80f";
export var playIconShape = "index-module--playIconShape--cd35c";
export var playIconShapeActive = "index-module--playIconShapeActive--8712d";